import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    FormControl, FormControlLabel,
    Grid, Radio,
    RadioGroup,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { ModalActionProps } from 'models/AutoModals';


type ShipDateLimitDialogProps = {} & ModalActionProps<{
    after: boolean,
    date: string,
}>

const ShipDateLimitDialog = ({onFinish}: ShipDateLimitDialogProps) => {
    const {t} = useTranslation('cars');
    const [date, setDate] = useState<DateTime | null>(null);
    const [byDate, setByDate] = useState(true);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const after = parseInt(new FormData(event.currentTarget).get('after') as string);

        onFinish({
            after: after < 2 ? Boolean(after) : true,
            date: date?.toISODate() || '3000-01-01',
        });
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormControl>
                            <RadioGroup
                                aria-labelledby="ship-label"
                                name="after"
                                defaultValue="1"
                                onChange={e => setByDate(+e.target.value < 2)}
                            >
                                <FormControlLabel value="1" control={<Radio/>} label={t('ship_after')}/>
                                <FormControlLabel value="0" control={<Radio/>} label={t('ship_before')}/>
                                <FormControlLabel value="2" control={<Radio/>} label={t('stop_until_allowed')}/>
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        {byDate && (
                            <DatePicker
                                label={t('date')}
                                format="yyyy-MM-dd"
                                slotProps={{textField: {fullWidth: true, required: true}}}
                                onChange={setDate}
                                value={date}
                            />
                        )}
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('set')}</Button>
            </DialogActions>
        </Box>
    );
};

export default ShipDateLimitDialog;
